import { render, staticRenderFns } from "./FireCauseLocationHouseQuestion.vue?vue&type=template&id=fc3a90dc&scoped=true"
import script from "./FireCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./FireCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a90dc",
  null
  
)

export default component.exports